// extracted by mini-css-extract-plugin
export default {"myComponent":"HomeContent_myComponent__VDN+9","left":"HomeContent_left__oHSqz","right":"HomeContent_right__kZp19"};